import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyAttendanceListing } from './Pages';

export const DailyAttendanceRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={DailyAttendanceListing} />
        
    </Fragment>
)